import React from 'react';
import Truncate from '../common/truncate/Truncate';
export var CompanyName = function CompanyName(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/React.createElement("div", {
    className: "font-heading-medium-regular",
    "data-testid": "company-name"
  }, /*#__PURE__*/React.createElement(Truncate, null, name));
};